// AppDownloadSheet.jsx
import React, { useEffect, useRef, useState } from 'react';

export function AppDownloadSheet({ isVisible, onClose, appData, selectedPlatform }) {
    const sheetRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);

    // Используем переданную платформу или определяем автоматически
    const platform = selectedPlatform || 'windows';

    // Данные приложения (по умолчанию)
    const appInfo = {
        name: appData?.name || 'V2Fun',
        icon: appData?.icon || 'v2.png',
        descriptionIos: appData?.descriptionIos || 'Быстрый и стабильный VPN-клиент с поддержкой VLESS и Trojan протоколов',
        descriptionMacos: appData?.descriptionMacos || 'Быстрый и стабильный VPN-клиент с поддержкой VLESS и Trojan протоколов',
        descriptionAndroid: appData?.descriptionAndroid || 'Быстрый и стабильный VPN-клиент с поддержкой VLESS и Trojan протоколов',
        descriptionWindows: appData?.descriptionWindows || 'Быстрый и стабильный VPN-клиент с поддержкой VLESS и Trojan протоколов',
        deepLink: appData?.deepLink || 'happ://add/{link}',
        downloadUrls: {
            windows: appData?.windowsUrl || '#',
            macos: appData?.macosUrl || '#',
            android_google: appData?.androidGoogleUrl || '#',
            android_apk: appData?.androidApkUrl || '#',
            ios_ru: appData?.iosRuUrl || '#',
            ios_global: appData?.iosGlobalUrl || '#'
        }
    };

    useEffect(() => {
        if (isVisible) {
            setTimeout(() => setIsOpen(true), 10);
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            setIsOpen(false);
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    // Обработчики для свайпа
    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null || !sheetRef.current) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);
            sheetRef.current.style.transform = `translateY(${diff}px)`;
        }
    };

    const handleTouchEnd = (e) => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            handleClose();
        } else {
            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }
        }

        setStartY(null);
        setCurrentY(null);
    };

    // Обработчики для мыши
    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null || !sheetRef.current) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);
                sheetRef.current.style.transform = `translateY(${diff}px)`;
            }
        };

        const handleMouseUp = (e) => {
            const diff = currentY || 0;

            if (diff > 100) {
                handleClose();
            } else {
                if (sheetRef.current) {
                    sheetRef.current.style.transform = '';
                }
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleClose = () => {
        setIsOpen(false);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    const handleDownload = (url) => {
        if (url && url !== '#') {
            window.open(url, '_blank');
        } else {
            console.log('Ссылка для скачивания не настроена');
        }
    };

    const handleAddToApp = () => {
        const deepLink = appInfo.deepLink.replace('{link}', appData?.keyUrl);
        window.open(deepLink, '_blank');
    };


    const renderDescription = () => {
        if (platform === 'ios') {
        return(
            <>
                <p style={styles.descriptionText}>
                    {appInfo.descriptionIos}
                </p>
            </>
        )
        } else if (platform === 'android') {
            return(
                <>
                    <p style={styles.descriptionText}>
                        {appInfo.descriptionAndroid}
                    </p>
                </>
            )
        } else if (platform === 'windows') {
            return(
                <>
                    <p style={styles.descriptionText}>
                        {appInfo.descriptionWindows}
                    </p>
                </>
            )
        } else if (platform === 'macos') {
            return(
                <>
                    <p style={styles.descriptionText}>
                        {appInfo.descriptionMacos}
                    </p>
                </>
            )
        }
    }
    // Рендерим кнопки в зависимости от платформы
    const renderDownloadButtons = () => {
        if (platform === 'ios') {
            return (
                <>
                    <button
                        onClick={() => handleDownload(appInfo.downloadUrls.ios_ru)}
                        style={styles.downloadButton}
                        onMouseEnter={(e) => { e.target.style.backgroundColor = 'rgba(50, 215, 86, 0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                    >
                        App Store (RU)
                    </button>
                    <button
                        onClick={() => handleDownload(appInfo.downloadUrls.ios_global)}
                        style={styles.downloadButton}
                        onMouseEnter={(e) => { e.target.style.backgroundColor = 'rgba(50, 215, 86, 0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                    >
                        App Store (Global)
                    </button>
                </>
            );
        } else if (platform === 'android') {
            return (
                <>
                    <button
                        onClick={() => handleDownload(appInfo.downloadUrls.android_google)}
                        style={styles.downloadButton}
                        onMouseEnter={(e) => { e.target.style.backgroundColor = 'rgba(50, 215, 86, 0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                    >
                        Google Play
                    </button>
                    <button
                        onClick={() => handleDownload(appInfo.downloadUrls.android_apk)}
                        style={styles.downloadButton}
                        onMouseEnter={(e) => { e.target.style.backgroundColor = 'rgba(50, 215, 86, 0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                    >
                        APK
                    </button>
                </>
            );
        } else if (platform === 'macos') {
            return (
                <>
                    <button
                        onClick={() => handleDownload(appInfo.downloadUrls.ios_ru)}
                        style={styles.downloadButton}
                        onMouseEnter={(e) => { e.target.style.backgroundColor = 'rgba(50, 215, 86, 0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                    >
                        App Store (RU)
                    </button>
                    <button
                        onClick={() => handleDownload(appInfo.downloadUrls.ios_global)}
                        style={styles.downloadButton}
                        onMouseEnter={(e) => { e.target.style.backgroundColor = 'rgba(50, 215, 86, 0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                    >
                        App Store (Global)
                    </button>
                </>
            );
        }
        else {
            // Windows, macOS и другие десктопные платформы
            const downloadUrl =  appInfo.downloadUrls.windows;
            return (
                <button
                    onClick={() => handleDownload(downloadUrl)}
                    style={styles.downloadButton}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = 'rgba(50, 215, 86, 0.1)'; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                >
                    Скачать
                </button>
            );
        }
    };

    if (!isVisible) return null;

    return (
        <div style={styles.overlay}>
            <div
                style={{
                    ...styles.backdrop,
                    opacity: isOpen ? 1 : 0,
                    pointerEvents: isOpen ? 'auto' : 'none',
                }}
                onClick={handleClose}
            />
            <div
                ref={sheetRef}
                style={{
                    ...(platform === 'ios' || platform === 'android' ? styles.sheetMobile : styles.sheet),
                    transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
                    transition: currentY ? 'none' : 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                }}
            >
                <div style={styles.content}>
                    <div
                        style={styles.dragHandle}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div style={styles.dragIndicator} />
                    </div>

                    <div style={styles.iconContainer}>
                        <img
                            src={`/images/${appInfo.icon}`}
                            alt={appInfo.name}
                            style={styles.icon}
                        />
                    </div>

                    <h3 style={styles.title}>
                        {appInfo.name}
                    </h3>

                    <div style={styles.descriptionBox}>
                        {renderDescription()}
                    </div>

                    <div style={styles.buttonsContainer}>
                        <div style={styles.downloadButtonsGroup}>
                            {renderDownloadButtons()}
                        </div>

                        <button
                            onClick={handleAddToApp}
                            style={styles.addButton}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#28a745'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#32d756'}
                        >
                            Добавить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 100000,
        pointerEvents: 'none',
    },
    backdrop: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(3px)',
        transition: 'opacity 0.3s ease',
    },
    sheet: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#0b1217',
        borderTopLeftRadius: '24px',
        borderTopRightRadius: '24px',
        padding: '16px 16px 10px 16px',
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.5)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        maxHeight: '80vh',
        overflowY: 'auto',
        pointerEvents: 'auto',
    },
    sheetMobile: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#0b1217',
        borderTopLeftRadius: '24px',
        borderTopRightRadius: '24px',
        padding: '16px 16px 114px 16px',
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.5)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        maxHeight: '80vh',
        overflowY: 'auto',
        pointerEvents: 'auto',
    },
    content: {
        width: '100%',
        maxWidth: '402px',
        margin: '0 auto',
    },
    dragHandle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '8px 0',
        cursor: 'grab',
        touchAction: 'none',
        userSelect: 'none',
        marginBottom: '16px',
    },
    dragIndicator: {
        width: '40px',
        height: '4px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '2px',
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '16px',
    },
    icon: {
        width: '80px',
        height: '80px',
        borderRadius: '20px',
        objectFit: 'cover',
        border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    title: {
        color: 'white',
        fontSize: '22px',
        fontWeight: 600,
        textAlign: 'center',
        margin: '0 0 12px 0',
    },
    descriptionBox: {
        backgroundColor: '#0f1513',
        borderRadius: '16px',
        padding: '20px 16px',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        marginBottom: '24px',
    },
    descriptionText: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '14px',
        textAlign: 'center',
        lineHeight: '1.5',
        margin: 0,
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        paddingBottom: '30px',
    },
    downloadButtonsGroup: {
        display: 'flex',
        gap: '12px',
    },
    downloadButton: {
        flex: 1,
        height: '48px',
        background: 'transparent',
        border: '1.5px solid #32d756',
        borderRadius: '16px',
        color: '#32d756',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.2s',
    },
    addButton: {
        width: '100%',
        height: '48px',
        background: 'linear-gradient(135deg, rgba(32, 213, 94, 0.38) 0%, #32D756 100%)',
        border: 'none',
        borderRadius: '16px',
        color: 'white',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    }
};